import { render, staticRenderFns } from "./SidemenuHeader.vue?vue&type=template&id=2e999b5b"
import script from "./SidemenuHeader.vue?vue&type=script&lang=js"
export * from "./SidemenuHeader.vue?vue&type=script&lang=js"
import style0 from "./SidemenuHeader.vue?vue&type=style&index=0&id=2e999b5b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports